const a = {
  id: "NebraskaPick4",
  name: "Pick 4",
  style: {
    colorPrimary: "#e83a23"
  }
};
export {
  a as default
};
